<div class="mosaic-node-container">
    <ng-container *ngIf="isEdit"
                  [ngTemplateOutlet]="settingsTemplate"
                  [ngTemplateOutletContext]="{ $implicit: node, level: level, index: index }">
    </ng-container>

    <ng-container *ngIf="!isEdit"
                  [ngTemplateOutlet]="template"
                  [ngTemplateOutletContext]="{ $implicit: node, level: level, index: index }">
    </ng-container>
    <ng-container *ngIf="isEdit && level == 0"
                  [ngTemplateOutlet]="editRefTemplate"
                  [ngTemplateOutletContext]="{ $implicit: node, level: level, index: index }">
    </ng-container>
    <ng-container *ngIf="isEdit && node.nodes == null && level > 0"
                  [ngTemplateOutlet]="editTemplate"
                  [ngTemplateOutletContext]="{ $implicit: node, level: level, index: index }">
    </ng-container>


    <as-split #splitContainer [direction]="directionMap[direction]" *ngIf="node.nodes != null"
              (dragEnd)="splitterDragEnded($event)"
              (dragStart)="splitterDragStarted($event)"
              (gutterAddClick)="addSplitNode($event)"
              [ngClass]="{'layout-editor':isEdit}"
              [isEdit]="isEdit"
              [gutterSize]="4">
        <as-split-area *ngFor="let item of node.nodes; let i = index"
                       [size]="item.size"
                       class="mosaic-area" [ngClass]="{'disable-element':dragging}">
            <mosaic-node [node]="item"
                         [template]="template"
                         [settingsTemplate]="settingsTemplate"
                         [editTemplate]="editRefTemplate"
                         [isEdit]="isEdit"
                         [direction]="invertDirection(direction)"
                         (changed)=changedNode()
                         (dragged)="nestedDragged()"
                         (deleteNode)="deleteNode($event)"
                         (mergeWithParent)="mergeNode($event)"
                         [level]="level+1"
                         [index]="i">
            </mosaic-node>
        </as-split-area>
    </as-split>
</div> 

<ng-template #editTemplate let-node let-level="level">
    <div class="flex-container content-center mosaic-node-edit-box">
        <!--<div class="spliter-icon-box mat-toolbar mat-secondary mosaic-node-remove">
            <mat-icon (click)="removeNodeEvent($event,node)"
                      class=" cursor-hand">cancel</mat-icon>
        </div>-->
        <icon-button class="mosaic-node-remove" (click)="removeNodeEvent($event,node)">cancel</icon-button>

        <div class="spliter-icon-box mat-toolbar mat-secondary">
            <span class="mat-secondary mat-icon cursor-hand mosaic-node-add"
                  [ngClass]="isVertiacalDirection(direction)? 'icon-add-column-bottom': 'icon-add-column-right'"
                  (click)="splitNodeEvent($event,node)"></span>
        </div>
    </div>
</ng-template>



